<template>
  <div>
    <translation :key="event.id" :value="event.name" :loading="loading" :id="event.id" @save="save"></translation>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex'
import translation from '@/components/settings/translations/translations'

export default {
  props: ['id'],
  components: { translation },
  data () {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters('events', {
      getById: 'getById'
    }),
    event () {
      return this.getById(this.id)
    }
  },
  methods: {
    ...mapActions('events', ['updateEvent']),

    save (id) {
      this.loading = true

      if (!this.event.name.fr) {
        delete this.event.name.fr
      }
      if (!this.event.name.en) {
        delete this.event.name.en
      }

      this.updateEvent({event: {id: this.event.id, name: this.event.name}})
        .then(() => {
          this.loading = 'success'
          this.$notify({title: 'Success', message: this.$root.$t('notifications.translations.edited'), type: 'success'})
        }).catch(() => {
          this.loading = 'failed'
          this.$notify.error({title: 'Error', message: this.$root.$t('notifications.unknown')})
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/translations/translations_event.vue